import React, { useEffect } from 'react';
import { Typography, Card, Divider } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const About = ({ analytics }) => {
    const { i18n } = useTranslation();
    const isRu = i18n.language === 'ru';

    useEffect(() => {
        analytics();
    }, [analytics]);

    return (
        <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
            <Card style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                <Title level={2} style={{ textAlign: 'center' }}>
                    {isRu ? 'О нас' : 'Մեր մասին'}
                </Title>
                <Divider />
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
                    {isRu 
                        ? 'AvtoDas — это онлайн-платформа, предназначенная для помощи будущим водителям в подготовке к теоретическому экзамену по ПДД в Армении. Наша цель — предоставить самые свежие и точные тесты, соответствующие требованиям Дорожной Полиции РА.'
                        : 'AvtoDas-ը օնլայն հարթակ է, որը նախատեսված է օգնելու ապագա վարորդներին պատրաստվել տեսական քննությանը։ Մեր նպատակն է տրամադրել ամենաթարմ և ճշգրիտ թեստերը, որոնք համապատասխանում են ՀՀ Ճանապարհային Ոստիկանության պահանջներին։'
                    }
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
                    {isRu
                        ? 'На нашем сайте вы найдете тесты, подробные объяснения дорожных знаков, психологические тесты и другие полезные материалы для обучения.'
                        : 'Մեր կայքում դուք կգտնեք թեստեր, ճանապարհային նշանների բացատրություններ, հոգեբանական թեստեր և այլ օգտակար նյութեր։'
                    }
                </Paragraph>
            </Card>
        </div>
    );
};

export default About;
